<label [for]="formField.name" class="Label-Text"
  >{{ formField.label }}<pm-asterisk *ngIf="formField.label && formField.required" /><span
    *ngIf="formField.type === FormFieldTypeEnum.SLIDER && displayValue(0) !== null"
    class="label-value"
    >&nbsp;(<span *ngIf="formField.prefix">{{ formField.prefix }}</span
    >{{ displayValue(0) }}<span *ngIf="formField.suffix">{{ formField.suffix }}</span
    >&nbsp;-&nbsp;<span *ngIf="formField.prefix">{{ formField.prefix }}</span
    >{{ displayValue(1) }}<span *ngIf="formField.suffix">{{ formField.suffix }}</span
    >)</span
  ></label
>
